module.exports = __webpack_public_path__ + "static/ai-4-047d96f68078ba4c62be931086e9262b.webp";